var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { LinearProgress, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { MuiButton, MuiPopup, MuiStack } from "../../../components";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { isLoadingState } from "../../../utils/utils";
import { APIKeys, SpareIssuesKeys, SpareIssueStatusEnum } from "../services/entity";
export var SerialNumberSelect = function (props) {
    var _crud$SpareIssuesKeys, _crud$SpareIssuesKeys2, _crud$SpareIssuesKeys3;
    var onChange = props.onChange, onSubmit = props.onSubmit, onClose = props.onClose, apiRequest = props.apiRequest, apiCall = props.apiCall, columns = props.columns, singleSelection = props.singleSelection, rowData = props.rowData, searchValue = props.searchValue;
    var _a = useState([]), selected = _a[0], setSelected = _a[1];
    var _b = useState([]), rows = _b[0], setRows = _b[1];
    var crud = useAppSelector(function (state) { return state.crud; });
    var getSerialNoResponse = crud[SpareIssuesKeys.GetSerialNumber];
    var _c = useState(false), warningPopupOpen = _c[0], setWarningPopupOpen = _c[1];
    var _d = useState([]), warningSelecion = _d[0], setwarningSelection = _d[1];
    var isMulitpleDoc = getLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC);
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var data = (_crud$SpareIssuesKeys = (_crud$SpareIssuesKeys2 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys2 === void 0 ? void 0 : _crud$SpareIssuesKeys2.data) !== null && _crud$SpareIssuesKeys !== void 0 ? _crud$SpareIssuesKeys : (_crud$SpareIssuesKeys3 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys3 === void 0 ? void 0 : _crud$SpareIssuesKeys3.data;
    var isDisable = isMulitpleDoc && mode == 'edit' || (data === null || data === void 0 ? void 0 : data.StatusName) == SpareIssueStatusEnum.Issued || (data === null || data === void 0 ? void 0 : data.StatusName) == SpareIssueStatusEnum.PartiallyReturned || (data === null || data === void 0 ? void 0 : data.StatusName) == SpareIssueStatusEnum.Returned || (data === null || data === void 0 ? void 0 : data.StatusName) == SpareIssueStatusEnum.Cancelled || (data === null || data === void 0 ? void 0 : data.StatusName) == SpareIssueStatusEnum.Closed;
    var issued = (rowData === null || rowData === void 0 ? void 0 : rowData.StatusName) == SpareIssueStatusEnum.Issued || isDisable;
    useEffect(function () {
        getData(apiRequest);
    }, []);
    useEffect(function () {
        if (searchValue) {
            var _crud$SpareIssuesKeys4;
            var filterArray = (_crud$SpareIssuesKeys4 = crud[SpareIssuesKeys.GetSerialNumber]) === null || _crud$SpareIssuesKeys4 === void 0 || (_crud$SpareIssuesKeys4 = _crud$SpareIssuesKeys4.data) === null || _crud$SpareIssuesKeys4 === void 0 || (_crud$SpareIssuesKeys4 = _crud$SpareIssuesKeys4.filter(function (item) {
                var _item$SerialNumber;
                return item === null || item === void 0 || (_item$SerialNumber = item.SerialNumber) === null || _item$SerialNumber === void 0 ? void 0 : _item$SerialNumber.includes(searchValue);
            })) === null || _crud$SpareIssuesKeys4 === void 0 ? void 0 : _crud$SpareIssuesKeys4.map(function (item) { return item; });
            if ((filterArray === null || filterArray === void 0 ? void 0 : filterArray.length) > 0) {
                setRows(filterArray);
            }
            else {
                setRows([]);
            }
        }
    }, [searchValue]);
    var getData = function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var _rowData$SerialNumber, _rowData$SerialNumber2, selectedSrNo, res, _rowData$selectedSeri, apiData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isDisable) return [3 /*break*/, 1];
                    selectedSrNo = rowData === null || rowData === void 0 || (_rowData$SerialNumber = rowData.SerialNumber) === null || _rowData$SerialNumber === void 0 ? void 0 : _rowData$SerialNumber.map(function (item) {
                        return item['SerialNumber'];
                    });
                    setRows((_rowData$SerialNumber2 = rowData === null || rowData === void 0 ? void 0 : rowData.SerialNumber) !== null && _rowData$SerialNumber2 !== void 0 ? _rowData$SerialNumber2 : []);
                    setSelected(selectedSrNo !== null && selectedSrNo !== void 0 ? selectedSrNo : []);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, apiCall({
                        request: request
                    })];
                case 2:
                    res = _a.sent();
                    if (res !== null && res !== void 0 && res.success) {
                        apiData = (res === null || res === void 0 ? void 0 : res.data) || [];
                        setRows(apiData);
                        if ((rowData === null || rowData === void 0 || (_rowData$selectedSeri = rowData.selectedSerialNo) === null || _rowData$selectedSeri === void 0 ? void 0 : _rowData$selectedSeri.length) > 0) {
                            setSelected(__spreadArray([], (rowData === null || rowData === void 0 ? void 0 : rowData.selectedSerialNo), true));
                        }
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var processRowUpdate = function (newRow) {
        var updatedRows = rows.map(function (row) {
            return row.id === newRow.id ? newRow : row;
        });
        setRows(updatedRows);
        return newRow;
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column',
        gap: '10px'
    }, isLoadingState(APIKeys) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(EditableDataGrid, {
        onChange: onChange,
        disableToolbarActions: true,
        columns: columns,
        rows: rows,
        dataGridProps: {
            disableColumnResize: true,
            checkboxSelection: true,
            disableColumnSorting: true,
            disableColumnMenu: true,
            disableRowSelectionOnClick: true,
            disableMultipleColumnsFiltering: true,
            disableMultipleColumnsSorting: true,
            disableMultipleRowSelection: singleSelection,
            rowSelectionModel: selected,
            hideFooter: true,
            processRowUpdate: processRowUpdate,
            getRowId: function (row) { return isDisable ? row === null || row === void 0 ? void 0 : row.SerialNumber : row === null || row === void 0 ? void 0 : row.id; },
            onCellClick: function (row) {
                if (!issued) {
                    var _row$row, _row$row2;
                    if ((getSerialNoResponse === null || getSerialNoResponse === void 0 ? void 0 : getSerialNoResponse.VoilationSetting) == 'Warn' && row !== null && row !== void 0 && (_row$row = row.row) !== null && _row$row !== void 0 && _row$row.Allow) {
                        if (selected !== null && selected !== void 0 && selected.includes(row === null || row === void 0 ? void 0 : row.id)) {
                            var filterArray = selected === null || selected === void 0 ? void 0 : selected.filter(function (i) { return i != (row === null || row === void 0 ? void 0 : row.id); });
                            setSelected(filterArray);
                        }
                        else {
                            setSelected(__spreadArray(__spreadArray([], selected, true), [row === null || row === void 0 ? void 0 : row.id], false));
                        }
                    }
                    else if ((getSerialNoResponse === null || getSerialNoResponse === void 0 ? void 0 : getSerialNoResponse.VoilationSetting) == 'Warn' && !(row !== null && row !== void 0 && (_row$row2 = row.row) !== null && _row$row2 !== void 0 && _row$row2.Allow)) {
                        if (selected !== null && selected !== void 0 && selected.includes(row === null || row === void 0 ? void 0 : row.id)) {
                            var filterArray = selected === null || selected === void 0 ? void 0 : selected.filter(function (i) { return i != (row === null || row === void 0 ? void 0 : row.id); });
                            setSelected(filterArray);
                        }
                        else {
                            setWarningPopupOpen(true);
                            setwarningSelection(__spreadArray(__spreadArray([], selected, true), [row === null || row === void 0 ? void 0 : row.id], false));
                        }
                    }
                    else if ((getSerialNoResponse === null || getSerialNoResponse === void 0 ? void 0 : getSerialNoResponse.VoilationSetting) == 'Restrict' || (getSerialNoResponse === null || getSerialNoResponse === void 0 ? void 0 : getSerialNoResponse.VoilationSetting) == 'Allow') {
                        if (selected !== null && selected !== void 0 && selected.includes(row === null || row === void 0 ? void 0 : row.id)) {
                            var filterArray = selected === null || selected === void 0 ? void 0 : selected.filter(function (i) { return i != (row === null || row === void 0 ? void 0 : row.id); });
                            setSelected(filterArray);
                        }
                        else {
                            setSelected(__spreadArray(__spreadArray([], selected, true), [row === null || row === void 0 ? void 0 : row.id], false));
                        }
                    }
                }
            },
            isCellEditable: function (params) {
                return isDisable ? !isDisable : (rowData === null || rowData === void 0 ? void 0 : rowData.StatusName) !== SpareIssueStatusEnum.Issued;
            }
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            justifyContent: 'flex-end',
            gap: 2
        }
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "saveButton",
        name: t('Save'),
        variant: "contained",
        sx: {
            fontSize: "14px",
            fontWeight: 500,
            padding: "10px 12px"
        },
        disabled: issued || (rows === null || rows === void 0 ? void 0 : rows.length) == 0,
        onClick: function () {
            onSubmit && onSubmit(selected, rows);
        }
    })), /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: warningPopupOpen,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            setWarningPopupOpen(false);
        },
        padding: "15px 0px 0px 15px"
        //headerIcon={FeaturedCancelIcon}
        ,
        showLoaderOnPopup: true
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, t('Warning')), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 1,
        marginTop: "16px"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        paddingY: 1
    }, getSerialNoResponse === null || getSerialNoResponse === void 0 ? void 0 : getSerialNoResponse.message)), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "confirmButton",
        name: t("Confirm"),
        style: {
            backgroundColor: systemColor.primary,
            borderColor: systemColor.primary,
            color: "#FFFFFF",
            fontSize: "16px",
            fontWeight: "500",
            marginTop: "16px",
            padding: "20px"
        },
        onClick: function () {
            setSelected(warningSelecion);
            setWarningPopupOpen(false);
        }
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "cancelButton",
        name: t("Cancel"),
        style: {
            borderColor: "#DEE4EB",
            color: "#6A7682",
            fontSize: "16px",
            fontWeight: "500",
            marginTop: "16px",
            padding: "20px"
        },
        onClick: function () {
            setWarningPopupOpen(false);
        }
    }))));
};
